import React from 'react';
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';
import './ArticleImage.less';

const ArticleImage = ({mediaFile, alignMedia, caption}) => {
    if (mediaFile && mediaFile.url) {
        const imageClass = `ArticleImage ArticleImage--${(
            alignMedia || 'full-width'
        ).toLowerCase()}`;

        return (
            <figure className={imageClass}>
                <ProgressiveImage
                    src={mediaFile.url}
                    alt={mediaFile.description}
                    withHeight={false}
                />
                {caption && (
                    <figcaption className="ArticleImage__caption small">
                        {caption}
                    </figcaption>
                )}
            </figure>
        );
    }
    return null;
};

export default ArticleImage;
